import { jsx as _jsx } from "@emotion/react/jsx-runtime";
import { ExternalLink } from '@/components/functional/Link/ExternalLink';
import { RouterLink } from '@/components/functional/Link/RouterLink';
/**
 * 動的にリンク・非リンクを切り替えるコンポーネント
 * @param props
 * @constructor
 */
export const WebLink = (props) => {
    const { children, className, disabled = false, externalLinkAttributes, onClick, routerLinkAttributes, target, to, } = props;
    if (disabled) {
        if (onClick) {
            return (_jsx("button", Object.assign({ className: className, onClick: onClick, type: 'button' }, { children: children })));
        }
        return _jsx("span", Object.assign({ className: className }, { children: children }));
    }
    if (to.indexOf('http') === 0 || to.indexOf('blob') === 0) {
        return (_jsx(ExternalLink, Object.assign({ className: className, href: to, onClick: onClick, target: target }, externalLinkAttributes, { children: children })));
    }
    return (_jsx(RouterLink, Object.assign({ className: className, onClick: onClick, target: target, to: to }, routerLinkAttributes, { children: children })));
};
